import {Injectable} from '@angular/core';
import * as APIM from '@common/utils/dist/models/api-messages.js';
import * as PL2 from '@common/utils/dist/models/models-pl2.js';
import {EntryStore} from '@stores/entry.store';
import {
  WebsocketMessageProcessor,
  WSMessageProcessorInput,
  WSMessageProcessorOutput,
} from './websocket-message-processor';
import {NEVER, Observable} from 'rxjs';
import {concatMap, map} from 'rxjs/operators';
import {WSMessageReceiverService} from '@services/ws-message-receiver.service';
import {EntryUtilsPL2 as EU} from '@common/utils/dist/utils/entry-utils-pl2.js';
import {ReceiveEventSuccessAction} from '@app/actions/receive-event-success.action';
import {ReceivePartialChangesTransformer} from '@stores/entry-store-transformers/receive-partial-changes-transformer';

function isPaginatedFetchResult(
  item: any,
): item is APIM.PaginatedFetchResult<any, any> {
  return item && Array.isArray(item.items);
}

@Injectable()
export class EntryFetchMessageProcessor implements WebsocketMessageProcessor {
  constructor(
    private entryStore: EntryStore,
    private wsMessageReceiverService: WSMessageReceiverService,
    private receiveEventSuccessAction: ReceiveEventSuccessAction,
    private receivePartialChangesTransformer: ReceivePartialChangesTransformer,
  ) {}

  processMessage(
    params: WSMessageProcessorInput,
  ): Observable<WSMessageProcessorOutput> {
    const msg = params.msg;
    if (msg.int === APIM.EventIntent.EntryFetched) {
      return this.receiveEventSuccessAction.execute(msg.id).pipe(
        concatMap(() =>
          this.wsMessageReceiverService
            .receive<APIM.RespondToFetchRequest>(msg)
            .pipe(
              map((request) => {
                const result = this._extractPayload(request);
                if (result.items.length > 0) {
                  this.entryStore.modifyStateWithTransformer(
                    result.items,
                    this.receivePartialChangesTransformer,
                  );
                }
                if (result.nQ) {
                  console.debug('[EntryFetchMessageProcessor] nQ:', result.nQ);
                }
                params.wsAPI.result(msg, request);
              }),
            ),
        ),
      );
    }
    return NEVER;
  }

  private _extractPayload(
    request: APIM.RespondToFetchRequest,
  ): APIM.PaginatedFetchResult<APIM.IndexQuery, PL2.AnyPartialEntryWithId> {
    if (!Array.isArray(request.c) || request.c.length === 0) {
      return {items: []};
    }
    if (isPaginatedFetchResult(request.c[0])) {
      return request.c[0] as APIM.PaginatedFetchResult<
        APIM.IndexQuery,
        PL2.AnyPartialEntryWithId
      >;
    }
    if (EU.isEntryLike(request.c[0])) {
      return {items: request.c as PL2.AnyPartialEntryWithId[]};
    }
    return {items: []};
  }
}
